/* Brand Support Popup — v3
   - Clones hidden template into <body> to prevent flash
   - Close button persists state per brand
   - Drag + viewport clamp
*/
(function () {
  var STORAGE_POS = "smsBrandPopupPosV2";
  var STORAGE_CLOSED = "smsBrandPopupClosedV2";

  function safeParse(json) {
    try { return JSON.parse(json); } catch (e) { return null; }
  }

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function getBrandKey(el) {
    return (el && el.getAttribute("data-brand")) ? el.getAttribute("data-brand") : "default";
  }

  function initOne(popup) {
    if (!popup || popup.dataset.smsInit === "true") return;
    popup.dataset.smsInit = "true";

    var brandKey = getBrandKey(popup);
    var closeBtn = popup.querySelector("[data-sms-brand-popup-close]");
    var dragHandle = popup.querySelector("[data-sms-brand-popup-drag]");

    // Restore closed state per brand
    var closedMap = safeParse(localStorage.getItem(STORAGE_CLOSED)) || {};
    if (closedMap[brandKey]) {
      popup.classList.add("is-closed");
      return;
    }

    // Restore position per brand
    var posMap = safeParse(localStorage.getItem(STORAGE_POS)) || {};
    var saved = posMap[brandKey];
    if (saved && typeof saved.left === "number" && typeof saved.top === "number") {
      popup.style.left = saved.left + "px";
      popup.style.top = saved.top + "px";
      popup.style.right = "auto";
      popup.style.bottom = "auto";
    }

    function savePos() {
      var r = popup.getBoundingClientRect();
      var m = safeParse(localStorage.getItem(STORAGE_POS)) || {};
      m[brandKey] = { left: Math.round(r.left), top: Math.round(r.top) };
      localStorage.setItem(STORAGE_POS, JSON.stringify(m));
    }

    function clampToViewport() {
      var pad = 8;
      var r = popup.getBoundingClientRect();
      var maxLeft = window.innerWidth - r.width - pad;
      var maxTop = window.innerHeight - r.height - pad;

      var left = clamp(r.left, pad, Math.max(pad, maxLeft));
      var top = clamp(r.top, pad, Math.max(pad, maxTop));

      popup.style.left = Math.round(left) + "px";
      popup.style.top = Math.round(top) + "px";
      popup.style.right = "auto";
      popup.style.bottom = "auto";
    }

    // Close button (no outside click close)
    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        popup.classList.add("is-closed");
        var m = safeParse(localStorage.getItem(STORAGE_CLOSED)) || {};
        m[brandKey] = true;
        localStorage.setItem(STORAGE_CLOSED, JSON.stringify(m));
      });
    }

    // Drag
    if (dragHandle) {
      var dragging = false;
      var startX = 0, startY = 0;
      var startLeft = 0, startTop = 0;

      dragHandle.style.touchAction = "none";

      dragHandle.addEventListener("pointerdown", function (e) {
        if (e.button !== 0 && e.pointerType === "mouse") return;

        dragging = true;

        var r = popup.getBoundingClientRect();
        popup.style.left = r.left + "px";
        popup.style.top = r.top + "px";
        popup.style.right = "auto";
        popup.style.bottom = "auto";

        startX = e.clientX;
        startY = e.clientY;
        startLeft = r.left;
        startTop = r.top;

        dragHandle.setPointerCapture(e.pointerId);
        popup.style.userSelect = "none";
      });

      dragHandle.addEventListener("pointermove", function (e) {
        if (!dragging) return;

        var dx = e.clientX - startX;
        var dy = e.clientY - startY;

        popup.style.left = Math.round(startLeft + dx) + "px";
        popup.style.top = Math.round(startTop + dy) + "px";

        clampToViewport();
      });

      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        popup.style.userSelect = "";
        clampToViewport();
        savePos();
        try { dragHandle.releasePointerCapture(e.pointerId); } catch (_) {}
      }

      dragHandle.addEventListener("pointerup", endDrag);
      dragHandle.addEventListener("pointercancel", endDrag);
    }

    window.addEventListener("resize", function () {
      if (popup.style.left && popup.style.top) {
        clampToViewport();
        savePos();
      }
    }, { passive: true });

    window.addEventListener("scroll", function () {
      if (popup.style.left && popup.style.top) clampToViewport();
    }, { passive: true });
  }

  function hydrateFromTemplates(scope) {
    var root = scope || document;
    var templates = root.querySelectorAll("[data-sms-brand-popup-template]");
    if (!templates.length) return;

    templates.forEach(function (tpl) {
      if (tpl.dataset.hydrated === "true") return;
      tpl.dataset.hydrated = "true";

      var clone = tpl.cloneNode(true);
      clone.removeAttribute("hidden");
      clone.setAttribute("aria-hidden", "false");
      clone.removeAttribute("data-sms-brand-popup-template");
      clone.setAttribute("data-sms-brand-popup", "");

      var brandKey = getBrandKey(clone);
      var existing = document.querySelector('[data-sms-brand-popup][data-brand="' + CSS.escape(brandKey) + '"]');
      if (existing) existing.remove();

      document.body.appendChild(clone);
      initOne(clone);

      tpl.remove();
    });
  }

  function boot(scope) {
    hydrateFromTemplates(scope);
    var popups = (scope || document).querySelectorAll("[data-sms-brand-popup]");
    popups.forEach(initOne);
  }

  document.addEventListener("DOMContentLoaded", function () { boot(document); });
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();
